Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var frontend = require('@ds-developer/frontend');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var AvataredAutocompleteOption = function AvataredAutocompleteOption(_a) {
  var optionLabel = _a.optionLabel,
    avatarColour = _a.avatarColour,
    _b = _a.avatarLabel,
    avatarLabel = _b === void 0 ? "" : _b;
  var useStyles = core.makeStyles({
    avatar: function avatar(_a) {
      var avatarColour = _a.avatarColour;
      return {
        backgroundColor: avatarColour
      };
    }
  });
  var classes = useStyles({
    avatarColour: avatarColour
  });
  return React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement(core.Avatar, {
    "data-test": "postcode-result",
    className: classes.avatar
  }, avatarLabel || frontend.getAvatarInitials(optionLabel)), React__default['default'].createElement(core.Typography, {
    "data-test": "postcode-result-text",
    style: {
      marginLeft: "10px"
    }
  }, frontend.upperCaseFirstCharacter(optionLabel)));
};
exports.default = AvataredAutocompleteOption;